import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { AppConstants } from '../../../core/constant/app.constant';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-help-center',
  standalone: true,
  imports: [RouterLink,CommonModule],
  templateUrl: './help-center.component.html',
  styleUrl: './help-center.component.scss'
})
export class HelpCenterComponent {
  token:any = '';
 constructor(
    private router: Router,
    private route: ActivatedRoute,
  ) {}
  ngOnInit(): void {
    this.getCurrenttoken();
  }

  getCurrenttoken(): void {
    this.token = localStorage.getItem(AppConstants.localStorage.authToken);
  }

  closeAccount(){
    this.router.navigate(['users/account/delete-account']);
  }
}
